import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/graphics/obj/graph-9.svg")